import { render } from "./user-liked.vue?vue&type=template&id=769b97b1"
import script from "./user-liked.vue?vue&type=script&lang=js"
export * from "./user-liked.vue?vue&type=script&lang=js"
script.render = render

export default script